import { useEffect } from 'react';
import { onSessionExpired } from '@/auth/sessionExpiredBus';
import { msalInstance } from '@/auth/msalConfig';
import { withBase } from '@/utils/basePath';

/**
 * Red de seguridad global (bug fila 100, UAT 2026-08-25): se monta UNA vez en `AppRouter` y escucha
 * el evento que dispara `getToken()`/`acquireTokenSilentSafe()` cuando Entra ID exige reautenticación
 * y el popup de recuperación también falla. Cubre cualquier pantalla que no maneje
 * `SessionExpiredError` explícitamente — las 4 de "Traducir auto." ya muestran su propio mensaje más
 * específico y no dependen de esto. `notifySessionExpired()` solo se dispara desde la rama MSAL/AAD
 * de `client.ts`/`acquireToken.ts` (Teams y Frontline resuelven antes por su cuenta), así que esto
 * nunca dispara en esos dos casos y no hace falta condicionar la llamada.
 *
 * 🔴 Reportado 2026-09-21 (Liliana Castillo, Sigma): el aviso visible con botón manual — "guarda lo
 * que puedas y vuelve a iniciar sesión" — dejaba a la persona seguir navegando por la app con la
 * sesión ya muerta, y el mensaje se leía como que había que decidir algo en vez de ser llevada de
 * inmediato al login. Petición explícita: en cuanto caduca el token, redirigir al login DE INMEDIATO,
 * sin mostrar ningún mensaje. Se quita el banner visible (y su CSS, sin más usos); este componente ya
 * no renderiza nada — solo escucha el evento y dispara la misma navegación que antes hacía el botón.
 *
 * `clearCache()` (2026-09-13) sigue yendo ANTES de navegar: sin esto, `/login` no se queda quieto —
 * MSAL sigue teniendo la cuenta cacheada en `localStorage` aunque el TOKEN real ya haya muerto, y
 * `LoginView` rebota solo de vuelta a `/app` en cuanto ve `getAllAccounts().length > 0`, sin darle a
 * la persona la oportunidad de reautenticarse de verdad con "Entra con correo Sigma".
 */
export function SessionExpiredBanner() {
  useEffect(() => onSessionExpired(() => {
    void msalInstance.clearCache().finally(() => {
      window.location.assign(withBase('/login'));
    });
  }), []);

  return null;
}
